import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

export default function StatCard({ title, value, subtitle, icon: Icon, color = 'blue', trend, loading, onClick, selected }) {
  const colors = {
    blue:   { bg: 'bg-blue-50',   icon: 'bg-blue-100 text-blue-600',   val: 'text-blue-700',   ring: 'ring-blue-400'    },
    green:  { bg: 'bg-emerald-50',icon: 'bg-emerald-100 text-emerald-600',val:'text-emerald-700',ring: 'ring-emerald-400' },
    yellow: { bg: 'bg-amber-50',  icon: 'bg-amber-100 text-amber-600',  val: 'text-amber-700',  ring: 'ring-amber-400'   },
    red:    { bg: 'bg-red-50',    icon: 'bg-red-100 text-red-600',      val: 'text-red-700',    ring: 'ring-red-400'     },
    purple: { bg: 'bg-purple-50', icon: 'bg-purple-100 text-purple-600',val: 'text-purple-700', ring: 'ring-purple-400'  },
    teal:   { bg: 'bg-teal-50',   icon: 'bg-teal-100 text-teal-600',   val: 'text-teal-700',   ring: 'ring-teal-400'    },
  };
  const c = colors[color] || colors.blue;

  if (loading) {
    return (
      <div className={`rounded-2xl p-5 ${c.bg} border border-white/60 shadow-card animate-pulse`}>
        <div className="skeleton h-10 w-10 rounded-xl mb-3" />
        <div className="skeleton h-7 w-24 mb-2" />
        <div className="skeleton h-4 w-32" />
      </div>
    );
  }

  return (
    <div
      onClick={onClick}
      className={`rounded-2xl p-5 ${c.bg} shadow-card hover:shadow-card-hover transition-all duration-200 animate-fade-in group
        ${onClick ? 'cursor-pointer active:scale-95 select-none' : ''}
        ${selected ? `border-2 ${c.ring} ring-2 ${c.ring} ring-offset-1` : 'border border-white/60'}
      `}
    >
      <div className="flex items-start justify-between mb-3">
        {Icon && (
          <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${c.icon} group-hover:scale-110 transition-transform`}>
            <Icon size={22} />
          </div>
        )}
        {trend !== undefined && (
          <div className={`stat-badge ${trend >= 0 ? 'up' : 'down'}`}>
            {trend >= 0 ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
            {Math.abs(trend)}%
          </div>
        )}
      </div>
      <p className={`text-3xl font-display font-bold ${c.val} leading-none mb-1`}>{value ?? '—'}</p>
      <p className="text-sm font-medium text-slate-700">{title}</p>
      {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
    </div>
  );
}
